import React, { useState } from 'react'
import RouteModal from '../../../../Component/BasicComponents/Modal/RouteModal';
import CustomInput from '../../../../Component/BasicComponents/CustomInput';
import ReusableDropdown from '../../../../Component/BasicComponents/Dropdowns/RouteDropdown';
import { Btn } from '../../../../AbstractElements';

type ProductCardProps = {
    setIsModalOpen?: any;
    isModalOpen?: any;
    toggleModal?: any;
    title?: any;
    handleSubmit?: any;
};
const OnboardWindowModal: React.FC<ProductCardProps> = ({ setIsModalOpen, isModalOpen, title, handleSubmit }) => {

    return (
        <RouteModal
            isOpen={isModalOpen}
            toggle={() => { setIsModalOpen(!isModalOpen) }}
            title={title}
            size="sm"
            content={
                <form onSubmit={handleSubmit}>
                    <div className="row mb-0">
                        <ReusableDropdown
                            options={[]}
                            // value={formValues.grade || selectedRowData?.GradeId}
                            onChange={(value: any) => {
                                // handleDropdownSelect("grade", value);

                            }}
                            DropdownHeading="Onboarding status*"
                        />
                        <CustomInput
                            type='date'
                            placeholder="Start Date"
                            disabled={false}
                            onChange={(e: any) => { }}
                            // value={holidayName}
                            required={true}
                            label="Start Date*"
                            style={{
                                border: "1px solid #EDEDED",
                                borderRadius: "4px",
                                padding: "10px",
                                fontSize: "14px",
                                backgroundColor: "#fff",
                            }}
                        />
                        <CustomInput
                            type='date'
                            placeholder="End Date"
                            disabled={false}
                            onChange={(e: any) => { }}
                            // value={holidayName}
                            required={true}
                            label="End Date*"
                            style={{
                                border: "1px solid #EDEDED",
                                borderRadius: "4px",
                                padding: "10px",
                                fontSize: "14px",
                                backgroundColor: "#fff",
                            }}
                        />

                        <div style={{ height: 20 }} />
                        <div className="d-flex justify-content-start gap-2">
                            <Btn
                                style={{ backgroundColor: "#43B9B2", color: "white" }}
                                type="submit"
                            >
                                {'Submit'}
                            </Btn>
                            <Btn
                                style={{
                                    backgroundColor: "#F9FAFC",
                                    color: "#000",
                                    border: "1px solid #E0E0E0",
                                }}
                                type="button"
                                onClick={() => { setIsModalOpen(false); }}
                            >
                                Cancel
                            </Btn>
                        </div>



                    </div>
                </form>
            }
        />
    )
}

export default OnboardWindowModal